import { triggerSimpleAjax } from "../../helpers/httpHelper";
import { OCR_INVOICE_API } from "../../helpers/constants/apiUrl";

const updateOcrInvoice = (id, payload) => {
    return new Promise((res, rej) => {
        const url = `${OCR_INVOICE_API}${id}/`;
        triggerSimpleAjax(
            url,
            "PATCH",
            payload,
            (response) => {
                res(response);
            },
            (err) => {
                rej(err);
            }
        );
    });
};

export default updateOcrInvoice;
